import _ from 'lodash';

import { logByrConfiguration } from './analytics';
import {
  BYR_SET_ROOF_ID,
  BYR_EDITOR_CHANGE_API_DATA,
  BYR_EDITOR_CHANGE_DATA,
  BYR_EDITOR_CHANGE_ZIP,
  BYR_EDITOR_SET_LOADING,
  BYR_EDITOR_SET_RECOMMENDED,
  BYR_EDITOR_SET_EDIT,
  BYR_EDITOR_TOGGLE_VISIBILITY,
  BYR_EDITOR_LOAD_CONFIGURATION,
  BYR_EDITOR_CHANGE_LEADS_EMAIL,
  BYR_EDITOR_CHANGE_STEP_ORDER,
} from '../Actions';

// BYR reducers, split from BYRConnectors/CustomizeConnectors so the Store
// (built into every pack) doesn't drag the BYR component tree along.

// BYR Data
const byrDefaults = {};
// eslint-disable-next-line default-param-last
export const byrConfigReducer = (state, action) => {
  const newState = _.cloneDeep(_.assign({}, byrDefaults, state));

  switch (action.type) {
    case BYR_SET_ROOF_ID:
      newState.roofId = action.roofId;
      return newState;
    default:
      return newState;
  }
};

// Why debounced? Usually single click in editor might create few actions
// (like - switch from edit -> new & load new data)
// we don't want this data to be logged twice, so we wait and run the last function that ran in the last 100ms.
// Since events are fired rapidly, 100ms should be enough (probably 10ms would be enough)
// If you stumble upon it and have time to restructure, feel free to do it. - akaminski
const debouncedLogByrConfiguration = _.debounce(logByrConfiguration, 100);

// Default Data
const byrEditorDefaults = {
  zip: null,
  configuration: { stepOrder: 'standard' },
  data: {},
  apiData: {},
  editExisting: false,
  loading: false,
};

// Reducer - main logic
// eslint-disable-next-line default-param-last
export const byrEditorReducer = (state, action) => {
  const newState = _.cloneDeep(_.assign({}, byrEditorDefaults, state));

  switch (action.type) {
    case BYR_EDITOR_SET_EDIT:
    case BYR_EDITOR_CHANGE_API_DATA:
    case BYR_EDITOR_LOAD_CONFIGURATION:
    case BYR_EDITOR_CHANGE_DATA:
    case BYR_EDITOR_CHANGE_ZIP:
    case BYR_EDITOR_SET_LOADING: {
      const updatedState = _.assign({}, _.cloneDeep(state), _.omit(action, 'type'));
      debouncedLogByrConfiguration(updatedState.data, updatedState.zip, updatedState.configuration);
      return updatedState;
    }
    case BYR_EDITOR_TOGGLE_VISIBILITY: {
      const { uid, category } = action;
      const catArray = newState.data[category].hidden || [];
      if (_.includes(catArray, uid)) newState.data[category].hidden = _.without(catArray, uid);
      else newState.data[category].hidden = catArray.concat(uid);
      debouncedLogByrConfiguration(newState.data, newState.zip);
      return newState;
    }
    case BYR_EDITOR_SET_RECOMMENDED:
      newState.data[action.category].recommended = action.uid;
      debouncedLogByrConfiguration(newState.data, newState.zip);
      return newState;
    case BYR_EDITOR_CHANGE_LEADS_EMAIL:
      _.set(newState, 'configuration.configuration.leadsEmail', action.leadsEmail);
      return newState;
    case BYR_EDITOR_CHANGE_STEP_ORDER:
      _.set(newState, 'configuration.configuration.stepOrder', action.order);
      _.set(newState, 'configuration.stepOrder', action.order);
      return newState;
    default:
      return newState;
  }
};
